export default __webpack_public_path__ + "static/media/gruzovik.17faecf8.svg";